import VIEWPORTS from './viewports'
import TAGMANAGER from './tagmanager'
import PARTSLOADER from './partsloader'
import CONTENT_TITLE from './contentTitle'
import COOKIE_POPUP from './cookie-popup'
import FULLCALENDAR from '../plugins/fullcalendar';



export default function INIT() {
  /*****
   * Promise
   */
  window.load = {
    'header': new $.Deferred,
    'contentFooter': new $.Deferred,
    'footer': new $.Deferred,
    'mapScript': new $.Deferred,
  }
  
  VIEWPORTS() // Viewportの置き換え
  TAGMANAGER() // GoogleTagManagerの挿入

  COOKIE_POPUP('cookie-popup','popup-hide') // 営業時間ポップアップの表示(引数はコンテナ名、Cookie名)
  
  //header.html, footer.html読み込み
  PARTSLOADER([
    {
      name: 'footer',
      loadhtml: '/asset/html/footer.html',
      target: 'footer #footerNav',
      method:'replaceWith',
      callback(r,_){
        console.info('%c%s%c is loaded','font-weight: bold',r.url,'');
      }
    },
    {
      name: 'contentFooter',
      loadhtml: '/asset/html/contentFooter.html',
      target: 'footer,#footer.ui-footer',
      method:'before',
      callback(r,_){
        console.info('%c%s%c is loaded','font-weight: bold',r.url,'');
        $('.homeContentslist').insertBefore('#footer');

        // fullcalendar挿入
        FULLCALENDAR(document.querySelectorAll('[data-plugin="calendar"]'),{
          defaultView: 'timeGridWeek',
          googleCalendarApiKey: 'AIzaSyB9ZtlG_lQuJPCOMZ5QtM7ofL2hnG2n4qQ',
          eventSources: [
            {
              googleCalendarId: '2ioq7k1ddcia89d99tadp5ca28@group.calendar.google.com',
              className: 'events'
            },
            {
              googleCalendarId: 'japanese__ja@holiday.calendar.google.com',
              className: 'holiday'
            }
          ]
        })
        
      }
    },
    {
      name: 'header',
      loadhtml: '/asset/html/header.html',
      target: (/^\/$/.test(location.pathname))? '#allbox>.containerWrap':'#allbox>.breadcrumbs',
      method:'before',
      callback(r,_){
        console.info('%c%s%c is loaded','font-weight: bold',r.url,'')
        $('header#header').remove()
        // gmenu current
        $('header .p-gnav').currentMenu({mode:1,default:999})
      }
    }
  ])
  // プライバシー・会社概要・サイトマップのコンテンツタイトル
  CONTENT_TITLE({
    'sitemap':'<span>サイトマップ</span><small>sitemap</small>',
    'privacy':'<span>プライバシーポリシー</span><small>privacy policy</small>',
    'profile':'<span>当院概要</span><small>profile</small>'
  })

  

  // DOM Ready
  $(() => {
    // <body>にクラス付与
    $.bodyClass();
    // svgスプライト読み込み
    $.loadSVG();
    // htmlデータ読み込み
    $('[data-load-html]').loadHtml();
    // カレントメニュー
    $('[data-plugin=currentMenu]').currentMenu({mode:0,default:999});
    // ページングテキスト
    $.pagingText({
      prev:'PREV',
      next:'NEXT',
      list:'LIST'
    })
    // ページトップリンクをスクロール量で表示する
    $.scrollspy({
      trigger:200,
      onBefore(/* pos */) {
        $('.p-gotop__wrap').addClass('hidden');
      },
      onAfter() {
        $('.p-gotop__wrap').removeClass('hidden');
      }
    })
    // 営業時間ポップアップをスクロール量で移動する
    $.scrollspy({
      trigger:10,
      onBefore() {
        $('[data-plugin="cookie-popup"]').addClass('is-pagetop');
      },
      onAfter() {
        $('[data-plugin="cookie-popup"]').removeClass('is-pagetop');
      }
    })
  })

}